import '../Button/index.scss'
import Button from '@Components/Buttons/Button'
import React from 'react'

interface IProps {
    disabled: boolean
    onClick: any
}

const SubmitWorkButton = (props: IProps) => (
    <Button mainColor type="primary" className="next" onClick={props.onClick} disabled={props.disabled}>
        Submit
    </Button>
)

export default SubmitWorkButton
